import {pathIs, url} from "../../utilities";
import {toastAlert} from "../../toastAlert";
import {confirmModal} from "../../confirmModal";
import axios from "axios";
import * as $ from "jquery";
import {EpMap} from "../../map/map";
import {Feature} from "ol";
import {Point} from "ol/geom";
import {fromLonLat} from "ol/proj";
import {EpHeatmap} from "../../map/layers/heatmap";
import {EpLayer} from "../../map/layers/layer";
import _ from 'lodash';
import {
    farInventoryLocationStyle,
    inventoryLocationStyle
} from "../../map/styles/inventory-locations";
import {LayerControl} from "../../map/controls/LayerControl";
import Spinner from "../../spinner";
import {EpInventoryObservations} from "../../map/layers/inventory-observations";
import FileDownload from "js-file-download";
import {addData} from "./add-data";
import {show} from "./show";
import {calculateAreas} from "./common";
import {locationsManagementPage} from "./locations";
import {farInventoryTrackedRouteStyle, inventoryTrackedRouteStyle} from "../../map/styles/inventory-tracked-routes";
import {EpInventoryLocationAreas} from "../../map/layers/inventory-location-areas";
import {EpInventoryLocationRoutes} from "../../map/layers/inventory-location-routes";
import {EpInventoryLocationTransects} from "../../map/layers/inventory-location-transects";
import {EpInventoryLocationPoints} from "../../map/layers/inventory-location-points";
import {EpInventoryLocations} from "../../map/layers/inventory-locations";
import {groupReport} from "./group-report";
import {EpBdlLayer} from "../../map/layers/bdl";
import {list} from "./list";


export const inventories_page = () => {

    const body = $('body');

    // add data page
    if (pathIs("*\/inventories\/[0-9]*\/add-data*")) {
        addData()
    }

    // locations page
    if (pathIs("*\/inventories\/[0-9]*\/edit\/locations*")) {
        locationsManagementPage()
    }

    // group report page
    if (
      pathIs("*\/inventories\/") ||
      pathIs("*\/inventories")
    ) {
        list()
    }

    // group report page
    if (pathIs("*\/inventories\/group-report*")) {
        groupReport()
    }

    // inventory page
    if (
        pathIs(".*\/inventories\/[0-9]*\/$", false) ||
        pathIs(".*\/inventories\/[0-9]*\?$", false) ||
        pathIs(".*\/inventories\/[0-9]{1,20}$", false)
    ) {
        show();
    }

    /// Variables
    let observations = typeof window._observations == 'undefined' ? [] : JSON.parse(window._observations);

    /// Tables
    const locationsTable = $('#locationsTable').DataTable();
    const templatesTable = $('#inventoryTemplatesTable');
    const itemsTable = $('#observedItemsTable');

    if (itemsTable.length > 0) {
        let filterColumns = [];
        if(window._is_forest_address_to_select) {
            const forestries = [];
            for(const observation of observations) {
                if(observation.subarea && observation.subarea.forestry && forestries.findIndex(f => f.id === observation.subarea.forestry.id) === -1) {
                    forestries.push(observation.subarea.forestry)
                }
            }

            filterColumns.push({
                index: 2,
                title: 'Leśnictwo',
                values: forestries.map(forestry => (
                    {
                        text: forestry.code,
                        value: forestry.full_code,
                        custom: (settings, searchData, index, rowData) => {
                            return rowData[2].startsWith(forestry.full_code);
                        }
                    }
                ))
            })
        }

        itemsTable.DataTable({
            filters: {
                columns: filterColumns
            },
            responsive: {
                details: {
                    renderer: function (api, rowIdx, columns) {
                        let hidden = columns.filter(column => column.hidden);

                        const ul = $('<ul class="dtr-details"></ul>')

                        let rowNode = $(api.row(rowIdx).node());
                        let controlNode = rowNode.find('[data-app-expand="child"]');

                        if (hidden.length === 1 && hidden[0].title === 'Uwagi') {
                            if (!hidden[0].data.length) {
                                return false;
                            }

                            if (!controlNode.hasClass('dtr-custom-control')) {
                                controlNode.addClass('dtr-custom-control');
                            }

                            $('#btnExpandComments').show();

                            if (!controlNode.hasClass('dtr-custom-control-expanded')) {
                                return false;
                            }
                        } else {
                            controlNode.removeClass('dtr-custom-control');
                            $('#btnExpandComments').hide();
                        }

                        for (let column of hidden) {
                            if (column.title === 'Uwagi' && column.data.length === 0) {
                                continue;
                            }

                            ul.append(`
                                <li data-dtr-index="${column.index}" data-dt-row="${rowIdx}" data-dt-column="${column.index}">
                                    <span class="dtr-title">${column.title}</span>
                                    <span class="dtr-data">${column.data}</span>
                                </li>
                            `)
                        }

                        return $('<table />').append(ul);
                    },
                }
            },
        })

        itemsTable.on( 'draw.dt', function () {
            $('[data-bs-toggle="tooltip"]').each(function() {
                new bootstrap.Tooltip(this)
            })
        } );

        body.on('click', '[data-app-expand="child"]', function () {
            if (!$(this).hasClass('dtr-custom-control')) {
                return;
            }

            if ($(this).hasClass('dtr-custom-control-expanded')) {
                $(this).removeClass('dtr-custom-control-expanded')
            } else {
                $(this).addClass('dtr-custom-control-expanded')
            }

            itemsTable.DataTable().api().draw(false);
        })

        body.on('click', '#btnExpandComments', function () {
            $('.dtr-custom-control').each(function () {
                if (!$(this).hasClass('dtr-custom-control-expanded')) {
                    $(this).click();
                }
            })
        })

        itemsTable.DataTable().api().search('').draw();

        $('#observedItemsTable_length').append($('#btnExpandComments'));
    }

    templatesTable.DataTable({
        responsive: {
            details: {
                display: $.fn.dataTable.Responsive.display.childRow,
                type: 'inline'
            }
        },
    })

    // Clone inventory handlers
    $('[data-bs-target="#cloneInventoryModal"]').click(function () {
        let id = $(this).data('id');

        const form = $('#cloneInventoryModal').find('form')

        form.attr('action', window._INVENTORY_CLONE_URL.replace('REPLACE_ID', id));
    })

    body.on('click', '.btnDeleteLocation', async function () {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć ten obszar?', {color: 'danger'});
        if (!confirm) return;

        try {
            const response = await axios.post(url(`api/inventories/locations/${$(this).data('id')}/delete`));

            if (response.data.code !== 200) {
                throw new Error();
            }

            let row = locationsTable.$(`tr[data-id=${$(this).data('id')}]`)
            locationsTable.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto obszar');
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia obszaru', {type: 'danger'})
        }
    })

    $("#editInventory select[name='inventory_type_id']").change(function () {
        let id = $(this).val();
        let modal = $('#typeDescriptionModal');

        if (modal.length > 0) {
            modal.find('.type-description').hide();
            modal.find('.type-description[data-id="' + id + '"]').show();
        }

        let videoId = window._tutorials[$(this).val()];
        $('.btnVideotutorial').attr('href', `https://www.youtube.com/embed/${videoId}`)
    }).change();

    $("[name='area']").on('input', function () {
        $(this).closest('.col-12').find('[name="area_changed_manually"]').val(1);

        if ($(this).val().length === 0) {
            $(this).closest('.col-12').find('[name="area_changed_manually"]').val(0);
        }
    })

    $('form#addUser select[name="type_id"]').change(function () {
        let elements = $(this)
            .closest('form')
            .find('[name="last_name"], [name="email"], [name="phone_number"], [name="address_line_1"], [name="address_line_2"], [name="postal_code"], [name="city"], [name="is_inventories_management_role"], [name="is_group_hunting_management_role"]')
            .closest('.input-group, .form-check')
            .parent()
            .closest('div');

        if (parseInt($(this).val()) === 7) {
            elements.hide();

            $(this).closest('form').find('label[for="addUser_first_name"]').text('Nazwa')
            $(this).closest('form').find('[name="first_name"]').attr('placeholder', 'Nazwa')
        } else {
            $(this).closest('form').find('label[for="addUser_first_name"]').text('Imię')
            $(this).closest('form').find('[name="first_name"]').attr('placeholder', 'Imię')
            elements.show();
        }
    }).trigger('change');

    calculateAreas();

    // Map
    let mapContainer = $("#map");
    if (mapContainer.length > 0) {
        const changeMapSize = () => {
            let height = 400;
            mapContainer.height(height - 32);
        }
        changeMapSize();

        let epMap = new EpMap({
            target: 'map',
            ruler: true,
            hideLabelsIfNecessary: true,
            fitSectorsAndBoundariesAfterInit: false
        });
        epMap.addSectorsLayer();

        if (typeof window._locations != 'undefined') {
            let locations = JSON.parse(window._locations);

            // locations layer
            let locationsLayer = new EpInventoryLocations(epMap.map);
            locationsLayer.setStyle(inventoryLocationStyle, farInventoryLocationStyle);
            locationsLayer.name = 'locations';
            locationsLayer.title = 'Obszary';

            epMap.changeStyleUnderZoom(locationsLayer)

            let locationThermalImagingAreasLayer = null;
            let locationThermalImagingTransectsLayer = null;
            let locationRoutesLayer = null;
            let locationPointsLayer = new EpInventoryLocationPoints();

            for (let location of locations) {
                locationsLayer.addFeature(location.coordinates, {
                    fields: {
                        name: location.name
                    }
                });

                // add points
                for(const point of location.points) {
                    locationPointsLayer.addFeature(
                        [point.longitude, point.latitude],
                        {fields: {name: point.name}}
                    )
                }

                // thermal imaging?
                if(parseInt(window._inventory_type) === 5) {
                    for(const geometry of location.geometries) {
                        if(parseInt(geometry.type) === 1) {
                            if (locationThermalImagingTransectsLayer === null) {
                                locationThermalImagingTransectsLayer = new EpInventoryLocationTransects(epMap.map)
                                epMap.addCustomLayer(locationThermalImagingTransectsLayer);
                            }

                            const line = locationThermalImagingTransectsLayer.addFeature(geometry.coordinates, {type: 'LineString'})
                            line.setStyle(inventoryLocationStyle)

                            locationThermalImagingTransectsLayer.createSimplifiedTransectsCollection(geometry.features)
                        } else {
                            if(locationThermalImagingAreasLayer === null) {
                                locationThermalImagingAreasLayer = new EpInventoryLocationAreas(epMap.map)
                                epMap.addCustomLayer(locationThermalImagingAreasLayer);
                            }

                            locationThermalImagingAreasLayer.addFeature(geometry.coordinates)
                        }
                    }

                    for(const route of location.routes) {
                        if(locationRoutesLayer === null) {
                            locationRoutesLayer = new EpInventoryLocationRoutes(epMap.map)
                            epMap.addCustomLayer(locationRoutesLayer);
                        }

                        locationRoutesLayer.addFeature(route.coordinates, {type: 'LineString'})
                    }
                }

                if(location.observers_line_coordinates) {
                    locationsLayer.addObserversLine(location.observers_line_coordinates)
                }

                if(location.beaters_line_coordinates) {
                    locationsLayer.addBeatersLine(location.beaters_line_coordinates)
                }
            }

            epMap.addCustomLayer(locationsLayer);
            epMap.addCustomLayer(locationPointsLayer);
            locationsLayer.fitInView();
        }

        if (typeof window._tracked_routes != 'undefined') {
            let trackedRoutes = JSON.parse(window._tracked_routes);

            // locations layer
            let trackedRoutesLayer = new EpLayer(epMap.map);
            trackedRoutesLayer.setStyle(inventoryTrackedRouteStyle, farInventoryTrackedRouteStyle);
            trackedRoutesLayer.name = 'tracked_routes';
            trackedRoutesLayer.title = 'Ścieżki';

            epMap.changeStyleUnderZoom(trackedRoutesLayer)

            for (let trackedRoute of trackedRoutes) {
                trackedRoutesLayer.addFeature(trackedRoute.coordinates, {type: 'LineString'});
            }

            epMap.addCustomLayer(trackedRoutesLayer);
        }

        epMap.addBoundariesLayer();

        console.log('enable bdl')
        console.log(EpBdlLayer.getAvailableLayersSync()[0])
        console.log(LayerControl.getLayerSavedVisibility('bdl-'+EpBdlLayer.getAvailableLayersSync()[0]?.Name))

        // enable bdl
        if (typeof LayerControl.getLayerSavedVisibility('bdl-'+EpBdlLayer.getAvailableLayersSync()[0]?.Name) == 'undefined') {
            LayerControl.setLayerSavedVisibility('bdl-'+EpBdlLayer.getAvailableLayersSync()[0]?.Name, true)
        }

        if (typeof LayerControl.getLayerSavedVisibility('bdl-'+EpBdlLayer.getAvailableLayersSync()[1]?.Name) == 'undefined') {
            LayerControl.setLayerSavedVisibility('bdl-'+EpBdlLayer.getAvailableLayersSync()[1]?.Name, true)
        }

        // if (typeof window._boundaries != 'undefined') {
        //     let boundaries = JSON.parse(window._boundaries);
        //     // for(let boundary of boundaries) {
        //     //     epMap.boundaries.addFeature(boundary);
        //     // }
        //     // epMap.boundaries.fitInView();
        // }

        if(typeof window._locations != 'undefined') {
            const locations = JSON.parse(window._locations);

            const districtsLoaded = [];
            for(const location of locations) {
                if(
                    location.district &&
                    !districtsLoaded.includes(location.district.id) &&
                    location.district.coordinates
                ) {
                    districtsLoaded.push(location.district.id);
                    epMap.boundaries.addFeature(location.district.coordinates);
                }
            }

            epMap.boundaries.fitInView();
        }

        if (typeof window._sectors != 'undefined') {
            epMap.sectors.addSectorsFromObject(JSON.parse(window._sectors));
        }

        if (typeof window._true_heatmap_data != 'undefined') {
            let trueHeatmapData = JSON.parse(window._true_heatmap_data);

            // true heatmap layer
            let trueHeatmapLayer = new EpHeatmap(epMap.map);
            trueHeatmapLayer.name = 'true_heatmap';
            trueHeatmapLayer.title = 'Mapa cieplna zwierzyny';
            trueHeatmapLayer.defaultVisibility = false;

            for (let data of trueHeatmapData) {
                let feature = new Feature({
                    geometry: new Point(fromLonLat([data.longitude, data.latitude])),
                    weight: data.weight
                });
                trueHeatmapLayer.getSource().addFeature(feature);
            }

            epMap.addCustomLayer(trueHeatmapLayer);
        }

        if (observations.length > 0) {
            let layer = new EpInventoryObservations();

            let table = itemsTable;
            if (table.length > 0) {
                table = table.DataTable().api();

                table.$('tr').click(function (e) {
                    if ($(e.target).is('button') || $(e.target).is('a') || $(e.target).hasClass('dtr-custom-control')) {
                        return;
                    }

                    let number = $(this).data('number')

                    layer.getSource().getFeatures().forEach(function (feature) {
                        if (feature.get('number') === number) {
                            let extent = feature.getGeometry().getExtent();
                            map.getView().fit(extent, {maxZoom: 17})
                        }
                    })
                })
            } else {
                table = null;
            }

            epMap.addCustomLayer(layer)
            epMap.changeStyleUnderZoom(layer, 10)

            let map = epMap.getOlMap();

            map.on("click", function (e) {
                if (table) {
                    table.search('');
                }

                layer.getSource().getFeatures().forEach(feature => feature.set('selected', false))

                map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
                    if (layer && layer.get('name') === 'observations') {
                        feature.set('selected', true);

                        if (table) {
                            table.search('obserwacja:' + feature.get('data').number);
                        }
                    }
                })

                if (table) {
                    table.draw();
                }
            });

            for (let observation of observations) {
                if (!observation.longitude || !observation.latitude) continue;

                layer.addObservation(observation);
            }

            epMap.setupTooltips('tooltip', ['observation'])
        }
    }

    /// Reports
    const correctTypeInputs = $('input[name="correct_type"]');
    const areaTypeInputs = $('input[name="area_type"]');

    if (pathIs("*\/inventories\/[0-9]*\/report*") || pathIs("*\/inventories\/group-report/step-2*")) {
        const handleCorrectTypeChange = (val) => {
            if (val === 1) {
                $('.correct-species-inputs input').attr('disabled', true);
                $('.correct-all-inputs input').attr('disabled', false);

                $('.correct-species-inputs label').css('opacity', '0.5');
                $('.correct-all-inputs label').css('opacity', '1');
            } else {
                $('.correct-species-inputs input').attr('disabled', false);
                $('.correct-all-inputs input').attr('disabled', true);

                $('.correct-species-inputs label').css('opacity', '1');
                $('.correct-all-inputs label').css('opacity', '0.5');
            }
        }
        handleCorrectTypeChange(parseInt(correctTypeInputs.val()));

        correctTypeInputs.change(function () {
            handleCorrectTypeChange(parseInt($(this).val()))
        })

        const handleAreaTypeChange = (val) => {
            if (val === 1) {
                $('.area-species-inputs input').attr('disabled', true);
                $('.area-all-inputs input').attr('disabled', false);

                $('.area-species-inputs label').css('opacity', '0.5');
                $('.area-all-inputs label').css('opacity', '1');
            } else {
                $('.area-species-inputs input').attr('disabled', false);
                $('.area-all-inputs input').attr('disabled', true);

                $('.area-species-inputs label').css('opacity', '1');
                $('.area-all-inputs label').css('opacity', '0.5');
            }
        }
        handleAreaTypeChange(parseInt(areaTypeInputs.val()));

        areaTypeInputs.change(function () {
            handleAreaTypeChange(parseInt($(this).val()))
        })

        $('input[name="is_insert_rdlp"]').change(function () {
            if ($(this).is(':checked')) {
                $('input[name="rdlp"]').attr('disabled', false);
            } else {
                $('input[name="rdlp"]').attr('disabled', true);
            }
        }).change();

        $('input[name="is_insert_observers_count"]').change(function () {
            $('.observes-count-inputs input').attr('disabled', !$(this).is(':checked'))

            if($(this).is(':checked')) {
                $('.observes-count-inputs').show()
            } else {
                $('.observes-count-inputs').hide()
            }
        }).change()

        let iframe = $('iframe');

        const setHeight = (iframe, spinner, counter = 0) => {
            let height = iframe.contentWindow.document.body.scrollHeight;

            if (counter > 50) {
                iframe.style.height = 'initial';
                spinner.destroy();
            }

            if (height === 0) {
                setTimeout(() => {
                    setHeight(iframe, spinner, counter++)
                }, 50)
            } else {
                iframe.style.height = height + 64 + 'px';
                spinner.destroy();
            }
        }

        const loadReportPreview = async () => {
            let form = new FormData($('#generateReport, #generateDetailedReport')[0]);
            let query = new URLSearchParams(form);

            if ((new URLSearchParams(window.location.search)).has('detailed')) {
                query.set('detailed', true);
            }

            let spinner = new Spinner($(iframe).parent(), null, null, 'absolute');
            iframe.height(0);

            iframe[0].src = url(`app/inventories/${form.get('id')}/report?preview=true&${query.toString()}`);

            iframe.on('load', function () {
                setHeight(this, spinner);
                iframe.off('load');
            })
        }
        loadReportPreview();

        $("#btnGetPdf").click(async function () {
            let form = $('#generateReport, #generateDetailedReport');

            let spinner = new Spinner(null, 'Trwa generowanie raportu PDF...');

            try {
                let response = await axios.post(url(`app/inventories/${$(this).data('id')}/report/pdf${window.location.search}`), new FormData(form[0]), {
                    responseType: 'blob'
                });

                if (response && response.status === 200) {
                    FileDownload(response.data, 'Raport.pdf');
                }
            } catch (err) {
                toastAlert('Nie udało się wygenerować PDF. Spróbuj ponownie później.', {type: 'danger'});
            }

            spinner.destroy();

            // let form = new FormData($('#generateReport')[0]);
            // const response = await axios.post(url(`app/inventories/${$(this).data('id')}/report/pdf`), form);
            //
            // console.log(response)
        })

        $("#btnGetDocx").click(async function () {
            let form = $('#generateReport, #generateDetailedReport');

            let spinner = new Spinner(null, 'Trwa generowanie raportu DOCX...');

            try {
                let response = await axios.post(url(`app/inventories/${$(this).data('id')}/report/docx${window.location.search}`), new FormData(form[0]), {
                    responseType: 'blob'
                });

                if (response && response.status === 200) {
                    FileDownload(response.data, 'Raport.docx');
                }
            } catch (err) {
                toastAlert('Nie udało się wygenerować DOCX. Spróbuj ponownie później.', {type: 'danger'});
            }

            spinner.destroy();
        })

        $("#btnGetXlsx").click(async function () {
            let form = $('#generateReport');
            let spinner = new Spinner(null, 'Trwa generowanie raportu...');

            // Get the selected report from the dropdown
            let selectedOption = $("#reportSelect").find(":selected");

            // Check if the user has selected a valid option
            if (!selectedOption.val()) {
                toastAlert('Wybierz raport.', {type: 'warning'});
                spinner.destroy();
                return;
            }

            const type = selectedOption.val(); // This is the report ID (type)
            const dataId = selectedOption.data('id');
            const dataName = selectedOption.data('name');

            if(type == -1){
                try {
                    let response = await axios.post(url(`app/inventories/${dataId}/report/pdf${window.location.search}`), new FormData(form[0]), {
                        responseType: 'blob'
                    });

                    if (response && response.status === 200) {
                        FileDownload(response.data, `${dataName}.pdf`);
                    }
                } catch (err) {
                    toastAlert('Nie udało się wygenerować PDF. Spróbuj ponownie później.', {type: 'danger'});
                }
            }
            else if(type == 0){
                try {
                    let response = await axios.post(url(`app/inventories/${dataId}/report/docx${window.location.search}`), new FormData(form[0]), {
                        responseType: 'blob'
                    });

                    if (response && response.status === 200) {
                        FileDownload(response.data, `${dataName}.docx`);
                    }
                } catch (err) {
                    toastAlert('Nie udało się wygenerować DOCX. Spróbuj ponownie później.', {type: 'danger'});
                }
            }
            else{
                try {
                    let response = await axios.post(url(`app/inventories/${dataId}/report/xlsx?type=${type}`), new FormData(form[0]), {
                        responseType: 'blob'
                    });

                    if (response && response.status === 200) {
                        FileDownload(response.data, `${dataName}.xlsx`);
                    }
                } catch (err) {
                    toastAlert('Nie udało się wygenerować XLSX. Spróbuj ponownie później.', {type: 'danger'});
                }

            }

            spinner.destroy();
        });

        $('#generateReport :input, #generateDetailedReport :input').change(_.debounce(function () {
            if($(this).attr('id') === 'reportSelect') {
                return
            }

            loadReportPreview()
        }, 1000))
    }
}
